import { resolveComponent as _resolveComponent, createVNode as _createVNode, createTextVNode as _createTextVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, Transition as _Transition } from "vue"

const _hoisted_1 = { class: "ghost-festival" }
const _hoisted_2 = /*#__PURE__*/_createTextVNode("遊戲規則")
const _hoisted_3 = /*#__PURE__*/_createTextVNode("我的獎品")
const _hoisted_4 = { class: "global-wrapper view-wrapper" }
const _hoisted_5 = { class: "global-container view-container" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Banner = _resolveComponent("Banner")
  const _component_Roulette = _resolveComponent("Roulette")
  const _component_Tab = _resolveComponent("Tab")
  const _component_Tabs = _resolveComponent("Tabs")
  const _component_router_view = _resolveComponent("router-view")
  const _component_BackTop = _resolveComponent("BackTop")
  const _component_Popup = _resolveComponent("Popup")

  return (_openBlock(), _createBlock("div", _hoisted_1, [
    _createVNode(_component_Banner, {
      imgUrl: _ctx.banner_url,
      haveCube: false
    }, null, 8, ["imgUrl"]),
    _createVNode(_component_Roulette, {
      playTimes: _ctx.play_times,
      imgPointUrl: _ctx.pointer_url,
      imgCircleUrl: _ctx.spinner_url,
      onOver: _cache[1] || (_cache[1] = ($event: any) => (_ctx.openPopup('message', 1))),
      onOpenPopup: _ctx.openPopup,
      onFinishGame: _ctx.finishGame,
      onSetClosePopupCallback: _ctx.setClosePopupCallback,
      haveCube: false
    }, null, 8, ["playTimes", "imgPointUrl", "imgCircleUrl", "onOpenPopup", "onFinishGame", "onSetClosePopupCallback"]),
    _createVNode(_component_Tabs, { class: "home-tabs" }, {
      default: _withCtx(() => [
        _createVNode(_component_Tab, {
          name: "Home-Regulation",
          isActive: _ctx.$route.name.includes('Home-Regulation'),
          onClick: _ctx.handleTabIndex
        }, {
          default: _withCtx(() => [
            _hoisted_2
          ]),
          _: 1
        }, 8, ["isActive", "onClick"]),
        _createVNode(_component_Tab, {
          name: "Home-Prize-Money",
          isActive: _ctx.$route.name.includes('Home-Prize'),
          onClick: _ctx.handleTabIndex
        }, {
          default: _withCtx(() => [
            _hoisted_3
          ]),
          _: 1
        }, 8, ["isActive", "onClick"])
      ]),
      _: 1
    }),
    _createVNode("div", _hoisted_4, [
      _createVNode("div", _hoisted_5, [
        _createVNode(_component_router_view, {
          dataRule: _ctx.game_rule,
          gameName: _ctx.game_name,
          playTimes: _ctx.play_times
        }, null, 8, ["dataRule", "gameName", "playTimes"])
      ])
    ]),
    _createVNode(_component_BackTop),
    _createVNode(_Transition, { name: "page" }, {
      default: _withCtx(() => [
        (_ctx.isDisplay)
          ? (_openBlock(), _createBlock(_component_Popup, {
              key: 0,
              modelValue: _ctx.code,
              "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => (_ctx.code = $event)),
              type: _ctx.popupTypeName,
              onClose: _ctx.handleClosePopup
            }, {
              title: _withCtx(() => [
                _createVNode("div", { innerHTML: _ctx.title }, null, 8, ["innerHTML"])
              ]),
              description: _withCtx(() => [
                _createVNode("div", { innerHTML: _ctx.description }, null, 8, ["innerHTML"])
              ]),
              _: 1
            }, 8, ["modelValue", "type", "onClose"]))
          : _createCommentVNode("", true)
      ]),
      _: 1
    })
  ]))
}